import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ChangeDetectorRef
} from '@angular/core';

import { environment } from 'environments/environment';

import { CategoryService, SystemSettingService } from '@app/api/api';
import { Router } from '@angular/router';
import { UtilService } from '@app/services/util.service';

import { TranslationService } from '@app/core/_base/layout';

import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'kt-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  host = environment.backendhost;
  listCategory = [];
  listCategoryFull = [];
  listCategoryMenuAll = [];
  iconCategoryDefault = '/assets/media/icons/svg/maintenance.svg';
  maxItemMenu = 11;
  hoverId$ = new BehaviorSubject<string | number | null>(null);
  hoverChildId$ = new BehaviorSubject<string | number | null>(null);

  treeCategory: any[] = [];
  childrenCategory: any[] = [];
  grandchildrenCategory: any[] = [];

  constructor(
    private cd: ChangeDetectorRef,
    private categoryService: CategoryService,
    private router: Router,
    private translationService: TranslationService,
    private systemSettingService: SystemSettingService
  ) {
    this.getListCategoryTest2();
  }

  ngOnInit() {}

  testChangeLanguage(lang: string) {
    this.translationService.setLanguage(lang);
  }

  // getListCategory() {
  //   this.categoryService.apiCategoriesGet().subscribe((res) => {
  //     if (res.success && res.data.length > 0) {
  //       this.listCategoryFull = [...res.data].filter(
  //         (x) => x.parent_id == null || x.parent_id == undefined || x.parent_id == ''
  //       );
  //       if (this.listCategoryFull.length > this.maxItemMenu) {
  //         this.listCategory = [...this.listCategoryFull].splice(0, this.maxItemMenu - 1);
  //         for (let i = 0; i < this.listCategory.length; i++) {
  //           this.listCategory[i].image = this.listCategory[i].image
  //             ? this.host + this.listCategory[i].image
  //             : this.iconCategoryDefault;
  //         }
  //       } else {
  //         this.listCategory = [...this.listCategoryFull];
  //       }

  //       let k = 0;
  //       let arr = [];
  //       for (let i = 0; i < this.listCategoryFull.length; i++) {
  //         if (k == this.maxItemMenu) {
  //           this.listCategoryMenuAll.push({
  //             colMenu: arr,
  //           });
  //           k = 0;
  //           arr = [];
  //           i--;
  //         } else {
  //           arr.push(this.listCategoryFull[i]);
  //           k++;
  //         }
  //       }
  //       if (arr.length > 0) {
  //         this.listCategoryMenuAll.push({
  //           colMenu: arr,
  //         });
  //       }
  //       this.cd.detectChanges();
  //     }
  //   });
  // }
  onHoverCategory(id: string | number) {
    this.hoverId$.next(id);
    this.hoverChildId$.next(null);

    const selectedCategory = this.treeCategory.find((category) => category.id === id);

    this.childrenCategory = selectedCategory ? selectedCategory.children || [] : [];

    this.grandchildrenCategory = [];
  }

  onHoverChildCategory(category: any) {
    this.hoverChildId$.next(category.id);
    this.grandchildrenCategory = category.children || [];
  }

  getListCategoryTest2() {
    this.categoryService.apiCategoriesWithPriority(true, 'body', true).subscribe((response) => {
      if (!response.success || !response.data) {
        this.treeCategory = [];
        return;
      }

      this.treeCategory = this.buildCategoryTree(response.data);
      this.cd.detectChanges();
    });
  }

  private buildCategoryTree(
    categories: any[],
    parentId: string | number | null = null,
    depth: number = 0
  ): any[] {
    if (depth >= 3) {
      return [];
    }

    return categories
      .filter((category) => {
        if (parentId === null) {
          return (
            category.parent_id === null ||
            category.parent_id === undefined ||
            category.parent_id === ''
          );
        }

        return category.parent_id == parentId;
      })
      .map((category) => ({
        ...category,
        children: this.buildCategoryTree(categories, category.id, depth + 1)
      }))
      .sort((firstCategory, secondCategory) => {
        const firstPriority =
          firstCategory.priority != null ? firstCategory.priority : Number.MAX_SAFE_INTEGER;

        const secondPriority =
          secondCategory.priority != null ? secondCategory.priority : Number.MAX_SAFE_INTEGER;

        return firstPriority - secondPriority;
      });
  }

  sortTree(data: any[]): any[] {
    return data
      .map((item) => ({
        ...item,
        children: item.children ? this.sortTree(item.children) : []
      }))
      .sort((a, b) => {
        const pa = a.priority != null ? a.priority : Number.MAX_SAFE_INTEGER;
        const pb = b.priority != null ? b.priority : Number.MAX_SAFE_INTEGER;
        return pa - pb;
      });
  }
  getProductByCategory(item) {
    this.router.navigate(['/searchbycategory'], {
      queryParams: {
        categoryId: item.id,
        categoryName: UtilService.slugify(item.name)
      }
    });
  }

  openVideoChannel() {
    this.systemSettingService.apiSystemSettingGet('type==VIDEO').subscribe((res) => {
      if (res.success && res.data.collection.length > 0) {
        const children = res.data.collection[0].children;
        if (children && children.length > 0) {
          let videoUrl = children[0].value;
          if (videoUrl) {
            if (!videoUrl.startsWith('http://') && !videoUrl.startsWith('https://')) {
              videoUrl = 'https://' + videoUrl;
            }
            window.open(videoUrl, '_blank');
          }
        }
      }
    });
  }
}
